import { isNil, isString } from 'lodash';

import { DateRange } from '@/store';
import { isLiveDateRange } from '@/utils/liveRange';

export const uriEncodeObjectProperties = (obj: Record<string, string | number | boolean>) => {
    return Object.keys(obj).reduce((acc, key) => {
        return {
            ...acc,
            [key]: encodeURIComponent(obj[key]),
        };
    }, {});
};

export const errorMessage = (error: null | string | { message: string }, defaultMessage = 'Error loading data') => {
    if (isNil(error)) {
        return null;
    }

    const message = isString(error) ? error : error.message;

    if (!message || message === 'Internal server error') {
        // default 500 message is not more useful than the context-specific message our caller passed in.
        return defaultMessage;
    }

    return message;
};

export const sensorDataStaleTime = (dateRange?: DateRange | null) => {
    // do not need to use a reactive `now` since time moves forward, worst that happens is we don't switch
    // to caching forever the moment endDate scrolls out of the live window (but we will next render when
    // this gets reevaluated).
    if (isLiveDateRange(dateRange)) {
        return 1000 * 60 * 5;
    }
    // if we're getting data from more than a LIVE_WINDOW_HOURS ago, we don't expect it to change again
    return Infinity;
};

/**
 * How long a sensor-data window with nothing watching it is kept.
 *
 * A window holds every row it answered with, so this is what bounds the rows kept for a range nothing is
 * looking at. The chunks a mounted chart still covers are observed and never collected, so panning and
 * widening a range hit cache whatever this says; two minutes is what a range returned to after that.
 */
export const SENSOR_DATA_GC_TIME_MS = 1000 * 60 * 2;
